import { ModalAnswerType, ModalButtons } from "../styles";
import ButtonDefault from "../../../../form/ButtonDefault";
import { IconAttachment, IconUpload } from "../../../../icons";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import api from "../../../../../services/api";
import toast from "react-hot-toast";
import { formatFileSize } from "../../../../../utility/byteSizeUtils";

const ResolvePendenciaDocumentos = forwardRef<any, {
    profissional: any;
    pendencia: any;
    arquivos: any;
    enviarArquivos: (arquivos: any) => void;
    resolvePendencia: () => void;
    fechaPendencia: () => void;
    setResposta: (resposta: string) => void;
}>(({
    profissional,
    pendencia,
    arquivos,
    enviarArquivos,
    resolvePendencia,
    fechaPendencia,
    setResposta,
}, ref) => {
    const [isUploadingFiles, setIsUploadingFiles] = useState(false);
    const [arquivosEnviando, setArquivosEnviando] = useState<File[]>([]);
    const [arquivosAnexados, setArquivosAnexados] = useState<any[]>(arquivos || []);
    const [respostaLocal, setRespostaLocal] = useState('');

    useEffect(() => {
        setArquivosAnexados(arquivos || []);
    }, [arquivos]);

    useImperativeHandle(ref, () => ({
        getArquivos: () => arquivosAnexados
    }));

    const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;
        if (!fileList || fileList.length === 0) return;

        const MAX_FILE_BYTES = 50 * 1024 * 1024;
        const errosLocal: string[] = [];
        const arquivosValidos: File[] = [];

        for (const file of Array.from(fileList)) {
            if (file.size > MAX_FILE_BYTES) {
                errosLocal.push(`Arquivo "${file.name}" excede 50MB.`);
            } else {
                arquivosValidos.push(file);
            }
        }

        if (errosLocal.length > 0) {
            errosLocal.forEach(msg => toast.error(msg));
        }

        if (arquivosValidos.length > 0) {
            setIsUploadingFiles(true);
            setArquivosEnviando(arquivosValidos);

            try {
                for (const file of arquivosValidos) {
                    const formData = new FormData();
                    formData.append('arquivo', file);

                    try {
                        const response = await api.post(`proposta/${pendencia.id_proposta}/anexos`, formData, {
                            onUploadProgress: (progressEvent: any) => {
                                if (progressEvent.total) {
                                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                }
                            }
                        });
                        
                        if (response.data.status !== 'success') {
                            throw new Error(response.data.message || 'Erro ao enviar arquivo');
                        }
                        
                        const arquivoData = response.data.result || {};
                        const fileName = arquivoData.caminho?.split('/').pop() || arquivoData.name || file.name;
                        
                        const novoArquivo = {
                            id_proposta_arquivo: arquivoData.id_proposta_arquivo,
                            caminho: fileName,
                            arquivo_final: arquivoData.arquivo_final || "não"
                        };

                        setArquivosAnexados(prev => {
                            const novosArquivos = [...prev, novoArquivo];
                            const nomesArquivos = novosArquivos.map(arq => arq.caminho).join(', ');
                            const respostaTexto = `Documento anexado: ${nomesArquivos}`;
                            setResposta(respostaTexto);
                            setRespostaLocal(respostaTexto);
                            return novosArquivos;
                        });
                    } catch (error: any) {
                        const errorMessage = error.response?.data?.message || error.message || `Falha ao enviar "${file.name}"`;
                        toast.error(errorMessage);
                    }
                }
            } finally {
                setIsUploadingFiles(false);
                setArquivosEnviando([]);
                if (e.target) {
                    e.target.value = '';
                }
            }
        }
    };
    return (
    <ModalAnswerType>
        <div className="title">
            {profissional?.nome.split(' ')[0]} {profissional?.id_usuario} solicitou um <span>documento</span>:
        </div>

        <div className="request">"{pendencia?.descricao}"</div>

        <div className="info-description">Resposta:</div>

        <div className="text">
            <textarea
                name="resposta"
                id="resposta"
                className="text-area"
                value={respostaLocal}
                placeholder="A resposta será preenchida automaticamente quando um arquivo for anexado..."
                readOnly
                style={{ backgroundColor: 'var(--cf8f9fa)', cursor: 'not-allowed' }}
            />
        </div>

        {
            arquivosEnviando && arquivosEnviando.length > 0 &&
            arquivosEnviando.map((file, index) => (
                <div className="loading-file" key={`loading-${index}`}>
                    <div className="loading-file-info">
                        <div className="loading-file-name">{file.name}</div>
                        <div className="loading-file-size">{formatFileSize(file.size)}</div>
                    </div>
                    <div className="loading-spinner">
                        <div className="spinner" />
                    </div>
                </div>
            ))
        }

        {
            arquivosAnexados?.length === 0 && (!arquivosEnviando || arquivosEnviando.length === 0) &&
            <div className="file">Sem arquivos anexados</div>
        }

        {
            arquivosAnexados?.length > 0 &&
            arquivosAnexados.map((row: any, index: number) => (
                <div className="file" key={`file-${index}`}>
                    <div className="file-details">
                        <div className="icon-title">
                            <div className="icon-file">
                                <IconAttachment color="#6B7280"/>
                            </div>
                            <div className="title-file">
                                {row.caminho}
                            </div>
                        </div>
                    </div>                                    
                </div>
            ))
        }

        <div className="add">
            <IconUpload />
            <input
                type="file"
                name="Files"
                className="file-input"
                onChange={handleFileUpload}
                disabled={isUploadingFiles}
            />
        </div>

        <ModalButtons>

            <ButtonDefault
                className="cancel"
                onClick={() => fechaPendencia()}
            >
                Voltar
            </ButtonDefault>
            <ButtonDefault
                className="continue"
                onClick={() => resolvePendencia()}
            >
                Resolver
            </ButtonDefault>

        </ModalButtons>

    </ModalAnswerType>
    )
});

export default ResolvePendenciaDocumentos;